import React, { useEffect, useState, useMemo } from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { advertMobx, decorationMobx, storeMobx } from '@mobxStore'
import { cartMobx, productMobx } from 'restaurant'
import { useHistoryNew, setDocumentTitle } from '@utils'
import CartBar from '../menu/components/CartBar'
import ProductItem from '@pages/menu/components/ProductItem/WaterfallProductItem'
import productStyleController from '@ctrls/productStyleController'
import { MallController, MallStyleController } from '@ctrls/mallController'
import MallProductItem from '@pages/mall/mall/components/ProductItem/WaterfallProductItem'
import { observer } from 'mobx-react'
import { BackPageBtn } from '@cps'
import { productMobx as mallProductMobx } from '@mobx/mall'
import { intersectionWith } from '@dt/fe-utils/dist/lodash'
import { MktController, CashierController } from '@ctrls/index'
import './index.scss'

// 存储计算结果
const advertHeightSave = {}
let calcTime = 0
const Advert: React.FC = (props: any) => {
  const history = useHistoryNew()
  const { adDetail, detailConfig, advertInfo } = advertMobx
  const { type, mallProducts, hightConfig = detailConfig || {} } = adDetail
  const [productList, setProductList] = useState([])
  const { img = [], bgColor = 'f4f4f4' } = hightConfig?.[type]
  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })

  /** 返回 */
  const handleBack = () => {
    if (type === 'product' && history.getPrevState() !== '/menu') {
      history.replace('/menu')
    } else {
      MktController.goBack(history)
    }
  }

  /** 高级设置下的图片和轮播图片判断展示 */
  const imgsNode = () => {
    return (
      img.length ? (
        img.map((pic) => <img key={pic} src={pic} />)
      ) : <img src={advertMobx.adDetail.pic} />
    )
  }

  /** 路由advertBrand 说明是小程序广告来的，需要重新获取门店，广告和餐品的数据 */
  const getAdvertInit = () => {
    const pathname = history.location.pathname
    if (pathname?.includes('advertBrand')) {
      const type = props.match?.params?.type
      const index = props.match?.params?.index
      if (type && index) {
        const _advertInfo = type === 'popUps' ? advertMobx.availableAdsGetStoreMap?.[type]['home'][index] : advertMobx.availableAdsMap[type][index]
        if (_advertInfo) {
          advertMobx.pick(_advertInfo, 'home')
          if (_advertInfo.type === 'product') {
            CashierController.initInPageForNoStore('advert', 'replace')
          }
        }
      }
    }
  }

  /** 初始化商城商品 */
  const getProductInit = async () => {
    const products = advertMobx.goToProductAdvert(advertMobx.adDetail.products)
    setProductList([...products])
  }

  /** 初始化商城商品 */
  const getMallInit = async () => {
    if (!mallProductMobx.isInited) {
      await mallProductMobx.init()
    }
    const list = intersectionWith(mallProductMobx.viewProducts, advertMobx.adDetail.mallProducts, (arrVal, othVal) => {
      return arrVal.id === othVal.productId
    })
    advertMobx.goToProductAdvert(list, 'mallProduct')
    setProductList([...list])
  }
  const [height, setHeight] = useState(420)
  const hashProduct = useMemo(() => {
    return productList.map(p => p.no).join('')
  }, [productList])
  const calcWaterfall = () => {
    if (calcTime > 50) return
    calcTime++
    const payload = (advertMobx.adDetail.type === 'mallProduct' ? MallStyleController.waterfall(productList, false, 'no', 'advert') : productStyleController.waterfall(productList, false, 'no', 'advert'))
    if (payload) {
      const { styleMap, height } = payload
      advertHeightSave[hashProduct] = payload
      setProductStyleMap(styleMap)
      setHeight(height)
    } else {
      setTimeout(() => {
        calcWaterfall()
      }, 300)
    }
  }
  useEffect(() => {
    if (productList.length && hashProduct) {
      if (advertHeightSave[hashProduct]) {
        setProductStyleMap(advertHeightSave[hashProduct].styleMap)
        setHeight(advertHeightSave[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 50)
      }
    }
  }, [productList, hashProduct])

  useEffect(() => {
    // 初始化装修数据
    advertMobx.showAdvert && getAdvertInit()
  }, [advertMobx.showAdvert, storeMobx.info])

  useEffect(() => {
    calcTime = 0
    return () => {
      productStyleController.clearWaterfallData()
      MallStyleController.clearWaterfallData()
    }
  }, [])

  useEffect(() => {
    if (advertMobx.advertInit) {
      if (productMobx.isInited && advertMobx.adDetail.type === 'product') {
        getProductInit()
      }
      if (advertMobx.adDetail.type === 'mallProduct') {
        getMallInit()
      }
      setDocumentTitle(advertMobx.adDetail.adTitle || i18n.t('advert.recommend'))
    }
  }, [advertMobx.advertInit, productMobx.isInited, advertMobx.adDetail])

  return (
    <IonPage className='poster-wrap'>
      {/* <UseHeader onBack={() => history.goBack()} /> */}
      <IonContent className='has-bar' style={{ backgroundColor: `#${bgColor}`, '--background': `#${bgColor}` }}>
        <BackPageBtn onClick={handleBack} />
        <div className='content-wrap'>
          <div className='poster-banner-img'>{imgsNode()}</div>
          {
            advertMobx.adDetail.intro && <div className='poster-intro' dangerouslySetInnerHTML={{ __html: advertMobx.adDetail.intro }} />
          }
          {
            type === 'mallProduct' ? (
              <div className='advert-mall-waterfall-template mall-product' style={{ height }}>
                {
                  productList.map((product) => {
                    return (<MallProductItem type='advert' key={product.no} style={productStyleMap[product.no] || { visibility: 'hidden' }} product={product} />)
                  })
                }
              </div>
            ) : (
              <div className='advert-waterfall-template advert-template poster-product' style={{ height }}>
                {
                  advertMobx.products.map((product) => {
                    const count = cartMobx.cartResult?.productNoToCntMap?.[product.no] || 0
                    return (<ProductItem type='advert' decorate={decorationMobx.mealDecorates || {} as TMealCommonDecorates} style={productStyleMap[product.no] || { visibility: 'hidden' }} key={product.no} product={product} count={count} />)
                  })
                }
              </div>
            )
          }
        </div>
      </IonContent>
      {type !== 'mallProduct' && <CartBar onClick={() => history.replace('/checkout')} />}
    </IonPage>
  )
}

export default observer(Advert)
